// Area Navigation component

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { ImageIcon } from '@moia-dev/pace-icons'
import { MobileAppstoreAssetsAreaRoutes } from './MobileAppstoreAssetsAreaRoutes'

export const MobileAppstoreAssetsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={MobileAppstoreAssetsAreaRoutes.route}
      Icon={ImageIcon}
    />
  )
}
